export default "__VITE_ASSET__BR77beqy__"